// Configuration API
const API_BASE_URL = import.meta.env.VITE_REACT_APP_API_EP_URI;

export interface MoodleSyncImport {
  label: string;
  last_import_at: string | null;
}

export type MoodleSyncJobName = 'imports' | 'stats';

export interface MoodleSyncRun {
  started_at: string;
  finished_at: string;
  outcome: 'ok' | 'no_token' | 'session_expired' | 'error';
  // Collecte du suivi : bilan envoyé par l'API
  summary?: {
    participants: number | null;
    grades: number | null;
    daily_rows: number | null;
    missing_columns: string[];
  };
}

export interface MoodleSyncJob {
  label: string;
  paused: boolean;
  requested: boolean; // « lancer maintenant » demandé, pas encore démarré
  next_at: string | null;
  last_run: MoodleSyncRun | null;
  interval_min?: number;        // imports
  items?: Record<string, MoodleSyncImport>; // imports
  interval_hours?: number;      // stats
  last_success_at?: string | null; // stats
}

export interface MoodleSyncStatus {
  running: { job: MoodleSyncJobName; started_at: string; step: string | null } | null;
  jobs: Record<MoodleSyncJobName, MoodleSyncJob>;
  session: 'ok' | 'expired' | 'unknown';
  api: 'ok' | 'token_refused' | 'unknown';
  alerts: Record<string, string>;
  now: string;
}

export type MoodleSyncAction = 'pause' | 'resume' | 'run-now';

async function callApi(path: string, method: 'GET' | 'POST', accessToken: string): Promise<any> {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`
    },
  });

  const json = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(json.message || `HTTP error! status: ${response.status}`);
  }

  return json;
}

class MoodleSyncService {

  async getStatus(accessToken: string): Promise<MoodleSyncStatus> {
    const json = await callApi('/admin/moodle-sync/status', 'GET', accessToken);
    return json.data;
  }

  async act(job: MoodleSyncJobName, action: MoodleSyncAction, accessToken: string): Promise<MoodleSyncStatus> {
    const json = await callApi(`/admin/moodle-sync/${job}/${action}`, 'POST', accessToken);
    return json.data;
  }
}

export const moodleSyncService = new MoodleSyncService();
